import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Compass } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/private-island-accommodation-westport/", label: "The Lodge" },
  { to: "/private-island-packages-prices/", label: "Packages & Prices" },
  { to: "/gallery/", label: "Gallery" },
  { to: "/journal/", label: "Island Journal" },
  { to: "/contact/", label: "Enquire" },
];

export default function NotFoundPage() {
  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) {
      robots.setAttribute("content", "noindex, follow");
      return () => robots.setAttribute("content", "index, follow, max-image-preview:large, max-snippet:-1");
    }
  }, []);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-navy px-6 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found | Collanmore Island Lodge" description="This page has drifted out with the tide. Explore the lodge, gallery, packages and enquire about your own private island escape in Clew Bay, County Mayo." path="/404" />
      <Compass className="h-10 w-10 text-gold" />
      <p className="mt-8 text-xs font-semibold uppercase tracking-[0.3em] text-gold-2">404 — Lost at sea</p>
      <h1 className="mt-4 font-display text-4xl font-medium text-ivory md:text-5xl">This page has drifted out with the tide</h1>
      <p className="mt-5 max-w-md text-sm font-light leading-relaxed text-ivory/70">
        The page you were looking for isn&rsquo;t here. Set a course for one of these instead.
      </p>
      <nav className="mt-10 flex flex-wrap items-center justify-center gap-3" data-testid="not-found-links">
        {LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="border border-ivory/20 px-6 py-3 text-[11px] font-semibold uppercase tracking-widest2 text-ivory/85 transition-colors hover:border-gold hover:text-gold-2"
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </main>
  );
}